/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Freebies_Redeemdialog_Title1Inputs */

const id_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih game gratis`)
};

const ms_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih permainan percuma`)
};

const da_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et gratis spil`)
};

const de_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle ein kostenloses Spiel aus`)
};

const en_us2_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a free game`)
};

const es_es2_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un juego gratis`)
};

const es_mx2_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un juego gratis`)
};

const fil_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng libreng laro`)
};

const fr_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un jeu gratuit`)
};

const it_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un gioco gratuito`)
};

const hu_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Válassz egy ingyenes játékot`)
};

const nl_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een gratis game`)
};

const no_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velg et gratis spill`)
};

const pl_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz darmową grę`)
};

const pt_br2_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um jogo grátis`)
};

const pt_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe um jogo grátis`)
};

const ro_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alege un joc gratuit`)
};

const fi_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse ilmainen peli`)
};

const sv_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett gratis spel`)
};

const vi_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một game miễn phí`)
};

const tr_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ücretsiz bir oyun seçin`)
};

const cs_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte si bezplatnou hru`)
};

const bg_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изберете безплатна игра`)
};

const ru_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите бесплатную игру`)
};

const uk_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виберіть безкоштовну гру`)
};

const ar_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر لعبة مجانية`)
};

const hi_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक मुफ़्त गेम चुनें`)
};

const th_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกเกมฟรี`)
};

const ja_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ゲームを選択`)
};

const zh_cn2_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一款免费游戏`)
};

const zh_hant1_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一款免費遊戲`)
};

const ko_freebies_redeemdialog_title1 = /** @type {(inputs: Freebies_Redeemdialog_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 게임 선택`)
};

/**
* | output |
* | --- |
* | "Choose a free game" |
*
* @param {Freebies_Redeemdialog_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const freebies_redeemdialog_title1 = /** @type {((inputs?: Freebies_Redeemdialog_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Freebies_Redeemdialog_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_freebies_redeemdialog_title1(inputs)
	if (locale === "ms") return ms_freebies_redeemdialog_title1(inputs)
	if (locale === "da") return da_freebies_redeemdialog_title1(inputs)
	if (locale === "de") return de_freebies_redeemdialog_title1(inputs)
	if (locale === "en-US") return en_us2_freebies_redeemdialog_title1(inputs)
	if (locale === "es-ES") return es_es2_freebies_redeemdialog_title1(inputs)
	if (locale === "es-MX") return es_mx2_freebies_redeemdialog_title1(inputs)
	if (locale === "fil") return fil_freebies_redeemdialog_title1(inputs)
	if (locale === "fr") return fr_freebies_redeemdialog_title1(inputs)
	if (locale === "it") return it_freebies_redeemdialog_title1(inputs)
	if (locale === "hu") return hu_freebies_redeemdialog_title1(inputs)
	if (locale === "nl") return nl_freebies_redeemdialog_title1(inputs)
	if (locale === "no") return no_freebies_redeemdialog_title1(inputs)
	if (locale === "pl") return pl_freebies_redeemdialog_title1(inputs)
	if (locale === "pt-BR") return pt_br2_freebies_redeemdialog_title1(inputs)
	if (locale === "pt") return pt_freebies_redeemdialog_title1(inputs)
	if (locale === "ro") return ro_freebies_redeemdialog_title1(inputs)
	if (locale === "fi") return fi_freebies_redeemdialog_title1(inputs)
	if (locale === "sv") return sv_freebies_redeemdialog_title1(inputs)
	if (locale === "vi") return vi_freebies_redeemdialog_title1(inputs)
	if (locale === "tr") return tr_freebies_redeemdialog_title1(inputs)
	if (locale === "cs") return cs_freebies_redeemdialog_title1(inputs)
	if (locale === "bg") return bg_freebies_redeemdialog_title1(inputs)
	if (locale === "ru") return ru_freebies_redeemdialog_title1(inputs)
	if (locale === "uk") return uk_freebies_redeemdialog_title1(inputs)
	if (locale === "ar") return ar_freebies_redeemdialog_title1(inputs)
	if (locale === "hi") return hi_freebies_redeemdialog_title1(inputs)
	if (locale === "th") return th_freebies_redeemdialog_title1(inputs)
	if (locale === "ja") return ja_freebies_redeemdialog_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_freebies_redeemdialog_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_freebies_redeemdialog_title1(inputs)
	return ko_freebies_redeemdialog_title1(inputs)
});
export { freebies_redeemdialog_title1 as "freebies.redeemDialog.title" }